var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 6C3 5.44772 3.44771 5 4 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H4C3.44772 7 3 6.55228 3 6ZM3 12C3 11.4477 3.44772 11 4 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H4C3.44772 13 3 12.5523 3 12ZM14 18C14 17.4477 13.5523 17 13 17H4C3.44772 17 3 17.4477 3 18C3 18.5523 3.44771 19 4 19H13C13.5523 19 14 18.5523 14 18Z"}));
}

MenuInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
